import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import styles from './FilterActionButtons.module.css';

type TProps = {
  onResetClick: () => void;
  onApplyClick: () => void;
};

export const FilterActionButtons = ({ onResetClick, onApplyClick }: TProps) => {
  return (
    <div className={styles.actionButtonsContainer}>
      <Button
        variant="tertiary"
        className={styles.button}
        onClick={onResetClick}
      >
        <Trans>Reset</Trans>
      </Button>
      <Button
        variant="primary"
        className={styles.button}
        onClick={onApplyClick}
      >
        <Trans>Apply</Trans>
      </Button>
    </div>
  );
};
